import { defineComponent, createElementBlock, createCommentVNode, openBlock, createElementVNode, Fragment, renderList, createVNode, normalizeStyle, toDisplayString } from 'vue';
import _sfc_main$2 from './basler-components.es79.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */

const _hoisted_1 = {
  key: 0,
  class: "product-detail-header-features"
};
const _hoisted_2 = { class: "product-detail-header-features__list" };
const _hoisted_3 = { class: "product-detail-header-features__icon" };
const _hoisted_4 = { class: "product-detail-header-features__text" };
const _hoisted_5 = { class: "product-detail-header-features__icon" };
const _hoisted_6 = { class: "product-detail-header-features__text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductDetailFeatures",
  props: {
    attributes: {},
    isLoading: { type: Boolean, default: false }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.attributes && _ctx.attributes.length > 0 || _ctx.isLoading ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("ul", _hoisted_2, [
          _ctx.isLoading ? (openBlock(), createElementBlock(Fragment, { key: 0 }, renderList(3, (index) => {
            return createElementVNode("li", {
              key: index,
              class: "product-detail-header-features__list-item"
            }, [
              createElementVNode("div", _hoisted_3, [
                createVNode(_sfc_main$1, { style: { "width": "24px", "height": "24px", "border-radius": "50%" } })
              ]),
              createElementVNode("span", _hoisted_4, [
                createVNode(_sfc_main$1, {
                  style: normalizeStyle(`width: ${index % 3 ? "70%" : "55%"}`)
                }, null, 8, ["style"])
              ])
            ]);
          }), 64)) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.attributes, (attribute) => {
            return openBlock(), createElementBlock("li", {
              key: `${attribute.value}-${attribute.label}`,
              class: "product-detail-header-features__list-item"
            }, [
              createElementVNode("div", _hoisted_5, [
                createVNode(_sfc_main$2, {
                  name: attribute.key
                }, null, 8, ["name"])
              ]),
              createElementVNode("span", _hoisted_6, toDisplayString(attribute.value) + " " + toDisplayString(attribute.label), 1)
            ]);
          }), 128))
        ])
      ])) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
